import { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { api, waktu } from "@/lib/api";
import { useAuth } from "@/lib/AuthContext";
import { ErpLayout, Card, Timeline, MODULES } from "@/erp/shell";
import { tanggal } from "@/lib/api";

export default function Dashboard() {
  const { user, can } = useAuth();
  const [d, setD] = useState(null);
  const modules = useMemo(() => MODULES.filter((m) => {
    if (!can(m.perm)) return false;
    if (m.hideForRoles?.some((r) => user?.roles?.includes(r))) return false;
    return true;
  }), [can, user]);
  useEffect(() => { api.get("/admin/dashboard").then((r) => setD(r.data)).catch(() => setD(false)); }, []);

  if (d === false) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[#FBF9F4] px-6 text-center">
        <div>
          <h1 className="font-display text-2xl font-bold text-[#141414]">Portal Jamaah</h1>
          <p className="mt-3 text-sm text-[#4A4844]">Akun Anda tidak memiliki akses ke ERP internal.</p>
          <Link to="/portal" className="btn-gold mt-6 inline-block rounded-xl px-5 py-2.5 text-sm font-bold">Buka Portal Jamaah</Link>
        </div>
      </div>);
  }

  const stats = d?.stats || {};
  const cards = [
    ["Paket Aktif", stats.products_published, `dari ${stats.products_total || 0} paket`],
    ["Jadwal Keberangkatan", stats.departures_total, "jadwal aktif"],
    ["Cabang", stats.branches_total, `${stats.subbranches_total || 0} cabang pembantu`],
    ["Umrah Consultant", stats.consultants_total, "mitra terdaftar"],
    ["Pengguna", stats.users_total, "akun terdaftar"],
    ["Dokumen Privat", stats.documents_total, "file tersimpan"],
    ["Produk Toko", stats.shop_products, "item katalog"],
    ["Artikel", stats.posts_total, "konten CMS"],
  ];

  return (
    <ErpLayout title={`Selamat datang, ${user?.full_name?.split(" ")[0] || ""}`} breadcrumb={["Dashboard"]}>
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4" data-testid="dashboard-stats">
        {cards.map(([label, value, sub], i) => (
          <Card key={label} className="reveal" >
            <div className="eyebrow">{label}</div>
            <div className="mt-2 font-display text-3xl font-bold text-[#141414]">{value ?? "-"}</div>
            <div className="text-xs text-[#8A867C]">{sub}</div>
          </Card>))}
      </div>

      <h2 className="mt-10 font-display text-xl font-semibold text-[#141414]">App Launcher</h2>
      <div className="mt-4 grid gap-4 sm:grid-cols-2 lg:grid-cols-4" data-testid="app-launcher">
        {modules.map((m, i) => (
          <Link key={m.key} to={m.to} data-testid={`launcher-${m.key}`}
            className="card-hover reveal rounded-xl border border-[#E5DEC9] bg-white p-5" style={{ animationDelay: `${i * 45}ms` }}>
            <m.icon className="text-[#C5A028]" size={22} />
            <div className="mt-3 text-sm font-bold text-[#121212]">{m.label}</div>
            <div className="text-xs text-[#8A867C]">{m.desc}</div>
            {m.soon && <span className="mt-3 inline-block rounded-full bg-[#F4EFE6] px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider text-[#8C6D1F]">Segera Hadir</span>}
          </Link>))}
      </div>

      <div className="mt-10 grid gap-6 lg:grid-cols-2">
        <Card>
          <div className="eyebrow">Aktivitas Terbaru</div>
          <div className="mt-4"><Timeline items={d?.activity || []} /></div>
        </Card>
        <Card>
          <div className="eyebrow">Keberangkatan Terdekat</div>
          <ul className="mt-4 space-y-3" data-testid="upcoming-departures">
            {(d?.upcoming_departures || []).map((u) => (
              <li key={u.id} className="flex items-center justify-between border-b border-[#F4EFE6] pb-2 text-sm">
                <span>{u.product_name}</span>
                <span className="font-semibold text-[#141414]">{tanggal(u.depart_date)}</span>
              </li>))}
            {(d?.upcoming_departures || []).length === 0 && <li className="text-sm text-[#8A867C]">Belum ada jadwal.</li>}
          </ul>
          <div className="mt-5 rounded-lg bg-[#FAF7F0] p-3 text-xs text-[#4A4844]">
            Izin aktif Anda: {(d?.permissions || []).length} permission · Zona waktu Asia/Jakarta · Mata uang IDR
          </div>
        </Card>
      </div>
    </ErpLayout>
  );
}
